// @core/api/endpoints/calendar/list_booking_links.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBookingLinksResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List booking links
 * Returns all booking links owned by the current user.
 */
export async function ListBookingLinks(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBookingLinksResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/booking-links`;
  const requestOptions = options;
  return client.get<ListBookingLinksResponse>(requestPath, { ...requestOptions, params });
}
